import state from "@/store/instance/state";
import getters from "@/store/instance/getters";
import mutations from "@/store/instance/mutations";
import * as actions from "@/store/instance/actions";

const instanceModule = {
	namespaced: true,
	getters,
	mutations,
	actions,
	state,
};

export default instanceModule;
